import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#13264A",
      "fill-rule": "evenodd",
      d: "m10.15 9.169 2.274 1.26a2.7 2.7 0 0 1 1.41 2.356v.548h-1v-.548c0-.605-.336-1.172-.894-1.48l-2.275-1.262zM3.577 10.43l2.274-1.261.485.874-2.275 1.261a1.7 1.7 0 0 0-.894 1.481v.548h-1v-.548a2.7 2.7 0 0 1 1.41-2.356",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#13264A",
      "fill-rule": "evenodd",
      d: "M8 3.167c-1.423 0-2.547 1.11-2.547 2.445v1.473c0 .679.288 1.392.767 1.936.478.542 1.112.877 1.78.877.669 0 1.302-.335 1.78-.877.48-.544.768-1.257.768-1.936V5.612c0-1.334-1.125-2.445-2.548-2.445M4.453 5.612c0-1.919 1.604-3.445 3.547-3.445s3.548 1.526 3.548 3.445v1.473c0 .947-.394 1.89-1.018 2.597C9.905 10.391 9.015 10.9 8 10.9s-1.905-.508-2.53-1.217c-.623-.706-1.017-1.65-1.017-2.597z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }